module.exports = __webpack_public_path__ + "static/media/hover.4167e954.gif";